"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var monitoring_step_status_1 = require("../../../constants/monitoring-step-status");
var MonitoringStepComponent = /** @class */ (function () {
    function MonitoringStepComponent() {
    }
    MonitoringStepComponent.prototype.ngOnInit = function () {
    };
    Object.defineProperty(MonitoringStepComponent.prototype, "monitoring", {
        get: function () {
            return this._monitoring;
        },
        set: function (monitoring) {
            this._monitoring = monitoring;
        },
        enumerable: true,
        configurable: true
    });
    MonitoringStepComponent.prototype.isCurrentStep = function (step) {
        if (step)
            return step === monitoring_step_status_1.MonitoringStepStatus.CURRENT;
        return false;
    };
    MonitoringStepComponent.ctorParameters = function () { return []; };
    return MonitoringStepComponent;
}());
exports.MonitoringStepComponent = MonitoringStepComponent;
//# sourceMappingURL=monitoring-step.component.js.map


// WEBPACK FOOTER //
// monitoring-step.component.js